<script>
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;
export default {
  extends: Bar,
  mixins: [reactiveProp],
  props:['chartData'],
  data: () => ({
    chartdatas: {
      labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [
        {
          label: '# of Votes',
          backgroundColor: 'rgba(104, 217, 208, 0.2)',
          borderColor: 'rgba(104, 217, 208, 1)',
          data: [22, 9, 13, 15, 12, 23],
          borderWidth: 1
        },
        {
          label: '# of  rejected Votes',
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          data: [12, 19, 3, 25, 22, 13],
          borderWidth: 1
        },
        {
          label: '# of valid Votes',
          backgroundColor: 'rgba(255, 206, 86, 0.2)',
          borderColor: 'rgba(255, 206, 86, 1)',
          data: [16, 25, 12, 19, 42, 3],
          borderWidth: 1
        },

      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true
        }
      },
      layout: {
        padding: {
          top: 20,
          right: 30,
          bottom: 20,
          left: 30
        }
      }
    }
  }),

  mounted () {

    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style>
</style>
